var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStyleNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 3V28L3 28C3 14.1929 14.1929 3 28 3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 3C27.3618 4.82005 26.3226 6.47328 24.9593 7.83738L7.83124 24.9638C6.46839 26.3248 4.81736 27.3624 3 28L3 10.7192C3 8.67196 3.8131 6.70854 5.26044 5.26091C6.70778 3.81327 8.67079 3 10.7176 3L28 3Z",
    fill: "#9467DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 0L10.7176 4.05848e-06C7.87495 3.93422e-06 5.1488 1.12949 3.1389 3.13981C1.12902 5.1501 1.24259e-07 7.87652 0 10.7192V28H4C6.24129 27.2137 8.2705 28.765 9.95118 27.0865L27.0812 9.95809C28.7624 8.27588 27.213 6.7444 28 4.5V0ZM26.4825 6.00001C27.1155 5.07351 27.6264 4.06533 28 3L10.7176 3C8.67079 3 6.70778 3.81327 5.26044 5.26091C3.8131 6.70854 3 8.67196 3 10.7192L3 28C4.06534 27.6263 5.07352 27.1151 6 26.4818C6.654 26.0348 7.26729 25.527 7.83124 24.9638L24.9593 7.83738C25.5246 7.27173 26.0342 6.65637 26.4825 6.00001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyleNote);
export default __webpack_public_path__ + "static/media/StyleNote.7ab4a2bb6b07f8dde569e70578a805c8.svg";
export { ForwardRef as ReactComponent };